/**
 * Loading Spinner Component
 * Displays a loading indicator with optional message
 */

export default function LoadingSpinner({ message = 'Loading...' }) {
  return (
    <div className="loading-container">
      <div className="spinner"></div>
      <p className="loading-message">{message}</p>
    </div>
  );
}
